import { createSelector } from '@reduxjs/toolkit';
import { selectItemById } from '../lib';
import { listenerSelector } from '..';

export const hasListener = createSelector(
  listenerSelector,
  selectItemById,
  (items, listener) => !!items[listener],
);
